<template>
  <div>
    <v-container>
      <v-card class="mb-4" v-if="coverImage || coverImageMobile">
        <v-card-text>
          <img
            v-if="coverImage"
            :src="coverImage.original_url"
            alt=""
            class="cover-desktop"
          />
          <img
            v-if="coverImageMobile"
            :src="coverImageMobile.original_url"
            alt=""
            class="cover-mobile"
          />
        </v-card-text>
      </v-card>
      <v-row>
        <v-col
          cols="12"
          md="6"
          class="event-wrapper"
          v-for="event in events"
          :key="event.id"
        >
          <event-card :event="event" short-text></event-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import EventCard from '../components/EventCard'

export default {
  name: 'CompanyEvents',
  components: {
    EventCard,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    events: {
      type: Array,
      required: true,
    },
    coverImage: {
      type: [Object, String],
      default: '',
    },
    coverImageMobile: {
      type: [Object, String],
      default: '',
    },
  },
}
</script>

<style scoped lang="scss">
.cover-desktop {
  width: 100%;
  display: none;

  @media screen and (min-width: 321px) {
    display: block;
  }
}

.cover-mobile {
  width: 100%;
  max-width: 320px;

  @media screen and (min-width: 321px) {
    display: none;
  }
}
</style>
